export var AppBaseRoutes;
(function (AppBaseRoutes) {
    AppBaseRoutes["REALIZE_OVERVIEW"] = "realize-overview";
    AppBaseRoutes["ERROR"] = "error";
})(AppBaseRoutes || (AppBaseRoutes = {}));
export var Locale;
(function (Locale) {
    Locale["EN"] = "en";
    Locale["EN_US"] = "en-US";
})(Locale || (Locale = {}));
export var Alignment;
(function (Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
})(Alignment || (Alignment = {}));
export var CEL_ICON_ALIGNMENTS;
(function (CEL_ICON_ALIGNMENTS) {
    CEL_ICON_ALIGNMENTS["LEFT"] = "left";
    CEL_ICON_ALIGNMENTS["RIGHT"] = "right";
})(CEL_ICON_ALIGNMENTS || (CEL_ICON_ALIGNMENTS = {}));
export var CEL_ICON_COLORS;
(function (CEL_ICON_COLORS) {
    CEL_ICON_COLORS["WHITE"] = "white";
    CEL_ICON_COLORS["BLACK"] = "black";
    CEL_ICON_COLORS["DISABLED"] = "disabled";
    CEL_ICON_COLORS["PRIMARY"] = "primary";
    CEL_ICON_COLORS["ERROR_SHADE"] = "error-shade";
    CEL_ICON_COLORS["GRAY_DUSTY"] = "gray-dusty";
})(CEL_ICON_COLORS || (CEL_ICON_COLORS = {}));
export var CEL_ICON_NAMES;
(function (CEL_ICON_NAMES) {
    CEL_ICON_NAMES["CARET_DOWN"] = "caret-down";
    CEL_ICON_NAMES["CARET_LEFT"] = "caret-left";
    CEL_ICON_NAMES["CARET_RIGHT"] = "caret-right";
    CEL_ICON_NAMES["CARET_UP"] = "caret-up";
    CEL_ICON_NAMES["INFORMATION"] = "information";
    CEL_ICON_NAMES["INFORMATION_CIRCLE"] = "information-circle";
    CEL_ICON_NAMES["ARROW_UP"] = "arrow-up";
    CEL_ICON_NAMES["ARROW_DOWN"] = "arrow-down";
    CEL_ICON_NAMES["ARROW_SORT"] = "arrow-sort";
    CEL_ICON_NAMES["SORT"] = "sort";
})(CEL_ICON_NAMES || (CEL_ICON_NAMES = {}));
export var CEL_ICON_SIZES;
(function (CEL_ICON_SIZES) {
    CEL_ICON_SIZES["CUSTOM"] = "custom";
    CEL_ICON_SIZES["REGULAR"] = "regular";
    CEL_ICON_SIZES["MEDIUM"] = "medium";
    CEL_ICON_SIZES["SMALL"] = "small";
    CEL_ICON_SIZES["XSMALL"] = "xsmall";
    CEL_ICON_SIZES["XXSMALL"] = "xxsmall";
})(CEL_ICON_SIZES || (CEL_ICON_SIZES = {}));
export var SortingOrder;
(function (SortingOrder) {
    SortingOrder["Ascending"] = "Ascending";
    SortingOrder["Descending"] = "Descending";
})(SortingOrder || (SortingOrder = {}));
